/**
 * Saves the browser's current push token on the signed-in member's / volunteer's profile.
 * Goes through the backend because members cannot write their own Firestore doc.
 */
import { auth } from '../utils/firebase';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const savePushToken = async (type, token) => {
  if (!auth.currentUser || !token) return false;
  const idToken = await auth.currentUser.getIdToken();
  const res = await fetch(`${API_URL}/api/push-token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ type, token }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Push token save failed (${res.status})`);
  }
  return true;
};

/**
 * Save subscription preferences for a member or volunteer via the backend (Admin SDK),
 * bypassing Firestore client-side rules that block member self-writes.
 * @param {'member'|'volunteer'} type
 * @param {{ email: boolean, push: boolean, whatsapp: boolean, directMail: boolean }} prefs
 */
export const saveSubscriptionPreferences = async (type, prefs) => {
  if (!auth.currentUser) throw new Error('Not signed in.');
  const idToken = await auth.currentUser.getIdToken();
  const res = await fetch(`${API_URL}/api/subscription-preferences`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ type, prefs }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.success === false) {
    throw new Error(body.message || `Could not save preferences (${res.status})`);
  }
  return true;
};
